import Config from 'react-native-config';
const RNConfig = Config || {};

export const COLORS = {
  white: '#fff',
  black: '#001533',
  black_20: '#00153333',
  black_70: '#001533B2',
  blueDarkText: '#090C39',
  mainLargeText: '#3876AA',
  mainLargeText_20: '#3876AA33',
  mainDarkText: '#2D5687',
  blueMain1: '#3D87BF',
  blueMain2: '#4499d2',
  blueMain3: '#4AA6E1',
  blueMain3_30: '#4AA6E14D',
  blueMain3_10: '#4AA6E11A',
  blueGradient1: '#6FA9D9',
  blueGradient2: '#204783',
  blueGradient3: '#6AAFFF',
  red: '#ED0000',
  red_30: '#ED00004d',
  greyBackground: '#F7F8FC',
  greyLight: '#E0E4ED',
  grey: '#27344E',
  grey1: '#4D5C71',
  grey2: '#5C697B',
  grey3: '#8697AB',
  grey4: '#C3CCD9',
  ripplefailed: '#fabbb8',
  transparent: 'transparent',
  orange: '#FF9900',
  pink: '#C900E0',
  green: '#23CE00',
  purple: '#6900E0',
  secondaryBlue: '#00A3BB',
  iconBorderColor: '#D7DDE6',
  imageShadow: '#97ACBF',
  pinkGradientOne: '#F377F599',
  pinkGradientTwo: '#EB77F500',
  lightRed: '#FF5151',
};

export const FONTS = {
  regularFont: 'Silka-Regular',
  lightFont: 'Silka-Light',
  boldFont: 'Silka-Bold',
  semiboldFont: 'Silka-SemiBold',
  mediumFont: 'Silka-Medium',
  blackFont: 'Silka-Black',
  blackItalicFont: 'Silka-BlackItalic',
  extraLightItalicFont: 'Silka-ExtraLightItalic',
  thinItalicFont: 'Silka-ThinItalic',
  regularItalic: 'Silka-RegularItalic',
};

export const DAYS_OF_WEEK = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export const USER_AUTH_STATUS = {
  undefigned: '0',
  login: '1',
  logout: '2',
};

export const DIABETES_TYPES = {
  'Type 1': 1,
  'Type 2': 2,
  LADA: 3,
  Gestational: 4,
  Other: 5,
};

export const BUTTON_TYPES = {
  Plain: 'Plain', // Plain button
  Bordered: 'Bordered', //  Bordered button
  Filled: 'Filled', //  Filled Background button
};

export const BS_CARD_TYPES = {
  BigCard: 'BigCard',
  SmallCard: 'SmallCard',
  SwipableCard: 'Swipablecard',
};

export const Pages = {
  Phone: 1,
  Verify: 2,
};

const SUPPORT_EMAIL = RNConfig.DIATHRIVE_SUPPORT_EMAIL || 'support@diathrive.com';
export const UNVERIFIED_ERROR = `Given Email is not verified, please contact support at ${SUPPORT_EMAIL}`;

export const DISABLE_ERROR = `Your Diathrive account has been disabled. This may mean your employer is no longer utilizing the Diathrive application. If you believe this is a mistake, or would like access to your blood sugar data, please contact support at ${SUPPORT_EMAIL}`;

// Member-services / support line. Dialable form feeds `tel:` links; display form
// is human-readable. Sourced from react-native-config so it can be swapped per
// environment without a code change; falls back to the number already used by
// ContactSupport + Terms of Service. NOTE: pending product-owner confirmation
// that this is the correct member-services number.
const SUPPORT_PHONE = RNConfig.DIATHRIVE_SUPPORT_PHONE || '+18668787477';
export const MEMBER_SERVICES_PHONE = SUPPORT_PHONE;
export const MEMBER_SERVICES_PHONE_DISPLAY =
  RNConfig.DIATHRIVE_SUPPORT_PHONE_DISPLAY || '1-866-878-7477';

export const FILTER_TYPE = {
  resource: 1,
  product: 2,
};

export const SEND_OTP_TYPES = {
  new: 'new',
  existing: 'existing',
  changePhone: 'changePhone',
};

export const KEYS = {
  numAttemptKey: 'num_attempts_submit_unique_employer_id',
  blockedTimeKey: 'time_blocked_submit_unique_employer_id',
  userToken: 'user_auth_token',
  refreshToken: 'refresh_token',
  faceIdEnabled: 'signin_with_faceid_enabled',
  userInfo: 'patient_login_info',
  userId: 'patient_id',
  userEligible: 'patient_eligible',
  employerUniqueId: 'employer_unique_id',
  phoneNumber: 'phone_number',
  email: 'user_email',
  password: 'user_password',
  bluetoothDeviceList: 'bluetooth_device_list',
  isLogin: 'is_user_login',
  OTPnumAttemptKey: 'num_attempts_submit_OTP',
  OTPblockedTimeKey: 'time_blocked_submit_OTP',
  signinNumAttemptKey: 'num_attempts_sign_in',
  signinBlockedTimeKey: 'time_blocked_sign_in',
  lastSyncedTime: 'last_synced_time',
  cartItems: 'cart_items',
  lastEligibilityCheckTime: 'last_eligibility_check_time',
  tokenVersion: 'token_version',
  timeFormat: 'time_format_preference', // '12' or '24'
  themeMode: 'theme_mode_preference', // 'system' | 'light' | 'dark' (dark mode, #67)
  healthKitSync: 'healthkit_sync_enabled', // 'true' | 'false' — opt-in Apple Health mirror (#65); a consent flag, not PHI
};

export const CONDITIONS = {
  numAttemptsAllowed: 5,
  timeDiffAllowed: 3600000, //give in milliseconds
};

export const RELATION_OPTIONS = {
  family: 'Family',
  friend: 'Friend',
  doctor: 'Doctor',
  other: 'Other',
};

export const GENDER_OPTIONS = {
  Woman: 2,
  Man: 1,
  Transgender: 3,
  'Non-binary/non-conforming': 4,
  'Prefer not to respond': 5,
};

export const VIEW_TYPE_RESOURCES = {
  Favorites: 'Favorites', //Favorites View
  Resources: 'Resources', //Resources View
  ResourcesWhileSearching: 'ResourcesWhileSearching', //Resources View While Searching
};

export const PRIVACY_POLICY_URL = 'https://diathrive.com/privacy-policy';
export const TERMS_AND_CONDITIONS_URL =
  'https://diathrive.com/terms-conditions';

export const MAX_FILE_UPLOAD_SIZE = 5000000;
